import { ButtonHTMLAttributes, FC, ReactNode } from "react";
import { SpinnerWrapper, StyledButton, StyledLink, StyledSpinner } from "./Button.styled";

type ButtonProps = {
  children: ReactNode;
  priority?: "primary" | "secondary";
  loading?: boolean;
  href?: string;
  className?: string;
} & Pick<ButtonHTMLAttributes<HTMLButtonElement>, "onClick" | "type" | "disabled">;

const Button: FC<ButtonProps> = ({ children, loading, disabled, priority = "primary", href, className, ...props }) => {
  const isDisabled = loading || disabled;

  const buttonContent = (
    <>
      {loading && (
        <SpinnerWrapper>
          <StyledSpinner />
        </SpinnerWrapper>
      )}
      {children}
    </>
  );

  if (href && !isDisabled) {
    return (
      <StyledLink href={href} className={className}>
        <StyledButton priority={priority} {...props}>
          {buttonContent}
        </StyledButton>
      </StyledLink>
    );
  }

  return (
    <StyledButton disabled={isDisabled} priority={priority} className={className} {...props}>
      {buttonContent}
    </StyledButton>
  );
};

export default Button;
